import { IrregularButtonLayout } from '../../IrregularButtonLayout/IrregularButtonLayout'
import { DialVariant1, DialVariant2 } from '../../RadialDial/RadialDial'
import { INTERCOM_BUTTON_ID } from '../constants/intercom'
import { useDispatchBannerAnalyticsEvent } from '../hooks/useDispatchBannerAnalyticsEvent'
import {
  BannerContainer,
  BannerCTAContainer,
  BannerCTASubText,
  BannerHeader,
  BannerHideIfContainerTooSmall,
  BannerSecondaryButton,
  BannerSubHeader,
  BannerSubHeaderBlue,
  BannerTextBody,
  BannerTextContainer,
} from './BannerComponents'

type TmBannerVariantProps = {
  onClickTmCta: () => void
}

export const TMBannerVariant1 = ({ onClickTmCta }: TmBannerVariantProps) => {
  useDispatchBannerAnalyticsEvent('tm_inactive_less_editing')

  return (
    <BannerContainer>
      <BannerTextContainer>
        <BannerSubHeader>2 MIN SETUP</BannerSubHeader>
        <BannerHeader>Try Custom Profiles and save hours of translation editing.</BannerHeader>
        <BannerTextBody>
          Custom AI Profiles can deliver up to 40% less editing effort and significantly more
          edit-free translations than the Base AI Profile. Set up in just 2 minutes and scale
          consistent, high-quality translations with ease.
        </BannerTextBody>
      </BannerTextContainer>
      <BannerHideIfContainerTooSmall>
        <DialVariant1 />
      </BannerHideIfContainerTooSmall>
      <BannerCTAContainer>
        <BannerSecondaryButton onClick={onClickTmCta}>
          Start translating and check
        </BannerSecondaryButton>
        <BannerCTASubText>
          Translate and compare your Custom Profile with the Base AI Profile and Google Translate
        </BannerCTASubText>
      </BannerCTAContainer>
    </BannerContainer>
  )
}

export const TMBannerVariant2 = ({ onClickTmCta }: TmBannerVariantProps) => {
  useDispatchBannerAnalyticsEvent('tm_inactive_zero_edits')

  return (
    <BannerContainer>
      <BannerTextContainer>
        <BannerSubHeader>2 MIN SETUP</BannerSubHeader>
        <BannerHeader>Get 2.5x more translations that require zero edits</BannerHeader>
        <BannerTextBody>
          Stop wasting time fixing AI translations. Custom AI profiles use your approved content to
          improve translation quality, so you get over twice as many translations that need no
          edits. Set up in just 2 minutes and scale reliable, high-quality translations with ease.
        </BannerTextBody>
      </BannerTextContainer>
      <BannerHideIfContainerTooSmall>
        <DialVariant2 />
      </BannerHideIfContainerTooSmall>
      <BannerCTAContainer>
        <BannerSecondaryButton onClick={onClickTmCta}>
          Start translating and check
        </BannerSecondaryButton>
        <BannerCTASubText>
          Translate and compare your Custom Profile with the Base AI Profile and Google Translate
        </BannerCTASubText>
      </BannerCTAContainer>
    </BannerContainer>
  )
}

export const TMBannerVariant3 = () => {
  useDispatchBannerAnalyticsEvent('tm_active_market_specific')

  return (
    <BannerContainer>
      <BannerTextContainer>
        <BannerSubHeaderBlue>MARKET SPECIFIC TRANSLATIONS</BannerSubHeaderBlue>
        <BannerHeader>Tailor your content for specific target group</BannerHeader>
        <BannerTextBody>
          Upgrade to curate exactly which examples AI sees. Create separate profiles for Marketing,
          Product, or Legal—ideal when your Translation Memory is mixed and you need higher
          precision per content type.
        </BannerTextBody>
      </BannerTextContainer>
      <IrregularButtonLayout>
        <BannerSecondaryButton id={INTERCOM_BUTTON_ID}>
          Unlock it and start translating
        </BannerSecondaryButton>
      </IrregularButtonLayout>
    </BannerContainer>
  )
}
